import {TheCryptGameConfig} from "../TheCryptGameConfig";

export class HighSymbolReelArea extends PIXI.Container{
    constructor() {
        super();
        this.name = "HighSymbolReelArea";
        this.position=TheCryptGameConfig.reelAreaPos;
    }
}